export default __webpack_public_path__ + "static/media/ui.d61fd100.svg";